var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tags-container" }, [
    _c("select", {
      staticClass:
        "single selectize selectize-multiple selectize-bordered selectized",
      attrs: { name: _vm.selectedTagsInputName, multiple: "" },
    }),
    _vm._v(" "),
    _vm.otherTags && _vm.otherTags.length
      ? _c("div", { staticClass: "other-tags-container" }, [
          _c("h3", [_vm._v("Other Details")]),
          _vm._v(" "),
          _c("p", { staticClass: "p-b-15" }, [
            _vm._v("Please provide additional details for 'other' selections"),
          ]),
          _vm._v(" "),
          _c(
            "fieldset",
            { staticClass: "other-tags-fieldset" },
            _vm._l(_vm.value, function (tag) {
              return tag.is_other_option
                ? _c("div", { key: tag.id, staticClass: "p-b-15" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(tag.database_name) +
                          _vm._s(
                            _vm._f("humanize")(
                              tag.is_other_option ? " - " + tag.type : ""
                            )
                          ) +
                          _vm._s(
                            _vm._f("humanize")(
                              tag.appearance_type
                                ? " - " + tag.appearance_type
                                : ""
                            )
                          ) +
                          ":"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: tag.other_text,
                          expression: "tag.other_text",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { maxlength: 190 },
                      domProps: { value: tag.other_text },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(tag, "other_text", $event.target.value)
                        },
                      },
                    }),
                  ])
                : _vm._e()
            }),
            0
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }